<div class="row" [ngClass]="{'add-margin':pageContent && pageContent.pageName.toLowerCase()=='solution'}">
    <div class="swot-locked col-md-12 text-center">
        <span *ngIf="pageContent && pageContent.image"><img appLazyLoad src="{{pageContent.image}}" /></span>
        <b *ngIf="pageContent && pageContent.pageHeading">{{pageContent.pageHeading}}</b>
        <p *ngIf="pageContent && pageContent.pageMessage">{{pageContent.pageMessage}}</p>
        <!-- <a (click)="reAttempt()" class="btn btn-blue">Re Attempt</a> -->
    </div>
</div>
